import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { en } from './en.ts';
import { ro } from './ro.ts';
import {
  readStoredReportLocale,
  storeReportLocale,
  type ReportLocale,
} from '../pages/sessionResultsLocales.ts';

const initial = readStoredReportLocale();

function setHtmlLang(lng: string) {
  document.documentElement.lang = lng.startsWith('en') ? 'en' : 'ro';
}

setHtmlLang(initial);

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en as Record<string, unknown> },
    ro: { translation: ro as Record<string, unknown> },
  },
  lng: initial,
  fallbackLng: 'ro',
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

i18n.on('languageChanged', (lng) => {
  setHtmlLang(lng);
  if (lng === 'en' || lng === 'ro') {
    storeReportLocale(lng as ReportLocale);
  }
});

export default i18n;
